import * as React from 'react';
import {loadModules} from 'esri-loader';
import {getServiceIntensityPolygonReal, getServiceIntensityPolygonAssigned} from "../layers/utils";

export default class Polygon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            graphic: null
        };
    }

    render() {
        return null;
    }

    componentDidMount() {
        loadModules(['esri/Graphic', 'esri/geometry/SpatialReference'])
            .then(([Graphic, SpatialReference]) => {
                const object = this.props.object;
                // Create a polygon geometry
                let polygon = {
                    type: 'polygon', // autocasts as new Polyline()
                    rings: this.props.geometry ? this.props.geometry : [],
                    spatialReference: new SpatialReference(this.props.wkid ? this.props.wkid : 3301)
                };

                //Add intensity additional object
                if(object && object.type && object.type.useServiceIntensityColors){
                    let graphicAssigned = new Graphic({
                        geometry: polygon,
                        symbol: getServiceIntensityPolygonAssigned(object.intensityAssigned, object.type)
                    });
                    this.props.view.graphics.add(graphicAssigned);
                }

                let color = this.props.color;
                let lineSymbol = {
                    type: "simple-fill", // autocasts as SimpleLineSymbol()
                    color: color || [247, 132, 12, 0.8],
                    style: "solid",
                    outline: {
                        color: this.props.outlineColor || 'red',
                        width: this.props.outlineWidth || 1,
                    }
                };

                if(object && object.type && object.type.useServiceIntensityColors){
                    lineSymbol = getServiceIntensityPolygonReal(object.intensityReal, object.type);
                }

                // Add the geometry and symbol to a new graphic
                const graphic = new Graphic({
                    geometry: polygon,
                    symbol: lineSymbol,
                    attributes: this.props.attributes ? this.props.attributes : null,
                    popupTemplate: this.props.content ? this.props.content : null,
                });

                this.setState({graphic});
                if(this.props.intensityAssignedOnly !== true){
                    this.props.view.graphics.add(graphic);
                }



            }).catch((err) => console.error(err));
    }

    componentWillUnmount() {
        this.props.view.graphics.remove(this.state.graphic);
    }
}
